export const DJ_ACCOUNT_LINKING_FAILURES_DASHBOARD_TITLE = 'DJ IdP Account Linking Failures';
export const DJ_ACCOUNT_LINKING_FAILURES_DASHBOARD_SLUG = 'account-linking-dashboard';
export const DJ_ACCOUNT_LINKING_FAILURES_DASHBOARD_CAPTION = 'Go to Dashboard';
export const DJ_ACCOUNT_LINKING_FAILURES_DOCUMENTATION_URL = 'https://opisnet.atlassian.net/wiki/x/B4Bij';
export const DJ_ACCOUNT_LINKING_FAILURES_DOCUMENTATION_TOOLTIP = 'Error documentation';
export const DJ_ACCOUNT_LINKING_FAILURES_DETAILS_FAILURE_TEXT = 'Failed to load execution details';

export const IMPORTS_TITLE = 'Imports';
export const IMPORTS_CAPTION = 'Go to Imports';
export const IMPORTS_SLUG = 'imports';
export const IMPORTS_ACCEPTABLE_DATE_FORMATS = 'Note: Acceptable date formats: YYYY-MM-DD, MM/DD/YYYY, M/D/YYYY';
export const IMPORTS_STAY_ON_PAGE_WARNING = 'Note: Please remain on this page after starting the upload to see the results. Navigating away will not cancel the import process.';
export const IMPORTS_DOCUMENTATION_URL = 'https://opisnet.atlassian.net/wiki/x/EADvjg';
export const IMPORTS_DOCUMENTATION_TOOLTIP = 'Imports documentation';
export const IMPORTS_FILE_NOT_CSV_ERROR = 'File type not text/csv';
export const IMPORTS_FILE_NOT_CSV_ERROR_NOTE = 'File is not in CSV format.';

export enum StepFunctionExecutionStatus {
    PROCESSING = 'Processing',
    FAILED = 'Failed',
    SUCCEEDED = 'Succeeded',
    USER_IGNORED = 'UserIgnored'
}

export enum StepFunctionExecutionSignalType {
    RETRY = 'Retry',
    IGNORE = 'Failure'
}

export enum ImportJobStatusName {
    UPLOADING = 'Initialized',
    PROCESSING = 'Processing',
    PARSING_ERRORS = 'CSV validation failed',
    IMPORT_ERRORS = 'Complete with kickback',
    SUCCESS = 'Complete without issue',
    CRITICAL_FAILURE = 'Critical failure'
}

export enum ImportJobStatusDialogTitle {
    UPLOADING = 'Uploading',
    PROCESSING = 'Processing',
    ERROR = 'Error',
    SUCCESS = 'Success',
    CRITICAL_FAILURE = 'Critical Failure'
}

export enum ImportJobStatusDialogMessage {
    UPLOADING = 'The file is parsing. Please remain on this page to see the results.',
    PROCESSING = 'The records are being processed. Please remain on this page to see the results.',
    PARSING_ERRORS = 'Errors were encountered due to the format of the file.',
    IMPORT_ERRORS = 'Errors were encountered while processing certain records; successful records were saved.',
    SUCCESS = 'All records were successfully saved.',
    CRITICAL_FAILURE = 'There was an unexpected error that prevented the import from completing. If the problem persists contact support.'
}
